import { Injectable, inject } from '@angular/core';
import { retry, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IBrandInfo } from '../../interfaces/brand/brand-info';
import { IBrandConfig } from '../../interfaces/brand/brand-config';
import { IBrandConfigLocalized } from '../../interfaces/brand/brand-config-localized';
import { SharedService } from '../../services/shared.service';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class BrandService {

  private readonly logger = inject(NGXLogger);

  private readonly brandInfoUrl: string = '/ui-pages/brand-info/{brandCode}';
  private readonly brandAdminUrl: string = '/brand-admin/brands/{brandCode}';
  private readonly brandLogoImageUrl: string = '/image-admin/brands/{brandCode}/logo-url';
  private readonly brandNonmobileImageUrl: string = '/image-admin/brands/{brandCode}/nonmobile-url';
  private readonly brandLocaleUrl: string = '/ui-pages/?????';

  private readonly walletronHeaders = new HttpHeaders()
    .set("request-origin", "csr-portal");

  constructor(
    private readonly http: HttpClient,  
    private readonly sharedService: SharedService      
  ) { }

  // // Retrieve one given brand from the Portal
  // public getBrandWithRegion(brandCode: string): Observable<IBrand> {
  //   let url = this.portalUrl + this.brandWithRegionUrl.replace('{brandCode}', brandCode);
  //   return this.http.get<IBrand>(url, {headers: this.portalHeaders, responseType: 'json'})
  //  .pipe(catchError(this.handleError))
  // }

  // Retrieve brand info from Walletron
  public getBrandInfo(region: string, brandCode: string, tag? : string): Observable<IBrandInfo> {
    let url = this.sharedService.getBaseUrlByRegion(region)
     + this.brandInfoUrl.replace('{brandCode}', brandCode);
    if (tag) {
      url += "?tags=" + tag;
    }
    // console.log('getBrandInfo - url', url);
    return this.http.get<IBrandInfo>(url, {headers: this.walletronHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  // Retrieve master brand config from Walletron
  public getBrandConfig(region: string, brandCode: string): Observable<IBrandConfig> {
    let url = this.sharedService.getBaseUrlByRegion(region)
     + this.brandAdminUrl.replace('{brandCode}', brandCode);
    return this.http.get<IBrandConfig>(url, {headers: this.walletronHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  // Retrieve brand's logo image URL from Walletron
  public getBrandLogoUrl(region: string, brandCode: string): Observable<any> {
    let url = this.sharedService.getBaseUrlByRegion(region)
     + this.brandLogoImageUrl.replace('{brandCode}', brandCode);
    return this.http.get<any>(url, {headers: this.walletronHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  // Retrieve brand's nonmobile image URL from Walletron
  public getBrandNonmobileUrl(region: string, brandCode: string): Observable<any> {
    let url = this.sharedService.getBaseUrlByRegion(region)
     + this.brandNonmobileImageUrl.replace('{brandCode}', brandCode);
    return this.http.get<any>(url, {headers: this.walletronHeaders, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  // Retrieve an image by its URL
  public getImageByUrl(imageUrl: string): Observable<any> {
    imageUrl = imageUrl.replace('http://','https://');
    // this.logger.log(`BrandService - getImageByUrl: imageUrl: ${imageUrl}`);
    return this.http.get(imageUrl, {headers: this.walletronHeaders, responseType: 'blob'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }


  // // Retrieve localized resources from Walletron
  // public getBrandConfigLocale(region: string, brandCode: string, locale: string, tag? : string): Observable<IBrandConfigLocalized> {
  //   var url = this.sharedService.getBaseUrlByRegion(region)
  //    + this.brandLocaleUrl.replace('{brandCode}', brandCode).replace('{locale}', locale);
  //   if (tag) {
  //     url += "?tags=" + tag;
  //   }
  //   return this.http.get<IBrandConfigLocalized>(url, {headers: this.walletronHeaders, responseType: 'json'})
  //   .pipe(
  //     catchError(this.sharedService.handleError)
  //   )
  // }

  // private getBaseUrlByRegion(region: string) {
  //   return environment.settings.regions.find(item => item.region === region.toLowerCase())?.baseUrl;
  // }


}
